// eslint-disable-next-line no-unused-vars
import request from '@/service/http'
/**
 * 版本初始化
 */
export function appUpdateInit (data) {
  return request({
    url: '/api/appVersionUpdate/appUpdateInit',
    method: 'post',
    data,
  })
}
/**
 * 版本初始化数据列表
 */
export function appUpdateSearch (data) {
  return request({
    url: '/api/appVersionUpdate/appUpdateSearch',
    method: 'post',
    data,
  })
}
/**
 * 新增版本初始化
 */
export function versionAddInit (data) {
  return request({
    url: '/api/appVersionUpdate/versionAddInit',
    method: 'post',
    data,
  })
}
/**
 * 新增版本
 */
export function saveVersion (data) {
  return request({
    url: '/api/appVersionUpdate/saveVersion',
    method: 'post',
    data,
  })
}
/**
 * 编辑版本初始化
 */
export function versionEditInit (data) {
  return request({
    url: '/api/appVersionUpdate/versionEditInit',
    method: 'post',
    data,
  })
}
/**
 * 编辑版本详情
 */
export function versionDetail (data) {
  return request({
    url: '/api/appVersionUpdate/versionDetail',
    method: 'post',
    data,
  })
}
/**
 * 编辑版本更新详情
 */
export function versionUpdate (data) {
  return request({
    url: '/api/appVersionUpdate/versionUpdate',
    method: 'post',
    data,
  })
}
/**
 * 版本删除
 */
export function versionDelete (data) {
  return request({
    url: '/api/appVersionUpdate/versionDelete',
    method: 'post',
    data,
  })
}
